<script>
import axios from 'axios'
import dayjs from 'dayjs'
import * as _ from 'lodash'
import { configuration } from '@utils/chat.const'
import { getHardwareId, getHardwareSerial } from '@utils/hardware'
import { formatPhoneNumber } from '@utils/phone-format'
import { httpServices } from '@utils/http-services'
import { services } from '@utils/services'
import store from '@state/store'
import OverlaySpinner from '@components/tabs/overlay-spinner.vue'

export default {
  components: { OverlaySpinner },
  data() {
    return {
      ...configuration,
      formatPhoneNumber: formatPhoneNumber,
      hardwareId: getHardwareId(this.$route.fullPath),
      hardwareSerial: getHardwareSerial(this.$route.fullPath),
      participants: [
        {
          id: 'hardware',
          name: this.theirSMS || 'SMS Hardware',
          imageUrl:
            'https://vanished-vue.s3.us-east-2.amazonaws.com/phone_gosj0a.png',
        },
      ],
      smsUrl: process.env.VUE_APP_KONSUL_API_URL,
      titleImageUrl: this.$auth.user.picture,
    }
  },
  mounted() {},
  beforeMount() {
    this.getGroups()
    this.getAWSSIMS()
    this.getWAN()
    this.pollSMS()
  },
  beforeDestroy() {
    this.cancelPoll()
  },
  methods: {
    getGroups() {
      if (this.$auth.user.profile.permissions.role !== 'admin') {
        httpServices.getGroups().then((res) => {
          this.groups = res
        })
      }
    },
    getAWSSIMS() {
      return axios
        .get(process.env.VUE_APP_KONSUL_API_URL + '/sims', {
          headers: {
            Authorization: 'Bearer ' + this.$auth.user.access_token,
          },
        })
        .then((res) => {
          const arr = res.data.Items.map((sim, i) => {
            return {
              ...sim,
              key: i,
              groupId: sim.meta.groupId,
              userId: sim.meta.userId,
              orgId: sim.meta.orgId,
              mtn: sim.meta.mtn,
              imsi: sim.meta.imsi,
              simSlot: sim.meta.simSlot,
              hardwareId: sim.meta.hardwareId,
            }
          })
          this.awsSIMS = arr.filter(
            (i) => i.hardwareId.toLowerCase() === this.hardwareId.toLowerCase()
          )
        })
    },
    getSMSviaAWS(lastEvaluatedKey) {
      this.cancelSource = axios.CancelToken.source()
      httpServices
        .getAWSMessagesPaginate(
          this.hardwareSerial,
          this.cancelSource.token,
          lastEvaluatedKey
        )
        .then(async (res) => {
          if (this.lastEvaluatedKey !== undefined) {
            this.lastEvaluatedKey = res.lastEvaluatedKey
          }
          if (!this.awsSentMessages.length) {
            this.awsSentMessages = res.messages.filter(
              (i) => i.outgoing === true
            )
          }
          const received = res.messages.filter(
            (i) => !i.outgoing && this.yourSMS.mtn === i.mtn
          )
          if (!this.awsReceivedMessages.length) {
            this.awsReceivedMessages = received
          }
          if (this.awsReceivedMessages.length) {
            this.awsReceivedMessages = _.uniqBy(
              [...this.awsReceivedMessages, ...received],
              'timestamp'
            )
          }

          this.buildMessageMap(this.awsReceivedMessages)
          this.buildMessageList()
          this.cancelSource = null
        })
    },
    getWAN() {
      this.getAWSSIMS().then((_data) => {
        this.getWANfromAWS()
      })
    },
    checkIfConnectionChanged(hardwareId, connectionId) {
      // kick user if another user changes sim on connection
      const conn = this.connections.filter(
        (i) => parseInt(i.meta.id) === parseInt(connectionId)
      )[0]
      if (conn) {
        return this.getConnectionsByHardware(this.hardwareId).then(() => {
          const cons = this.connections.filter(
            (i) => i.meta.id === conn.meta.id && i.meta.sim === conn.meta.sim
          )
          return !cons.length
        })
      }
    },
    buildWan() {
      const arr = []
      this.connections.forEach((conn) => {
        const sim = this.awsSIMS.filter((i) => i?.pk === conn?.meta?.sim)[0]
        if (sim) {
          arr.push(sim)
        }
      })
      // figments only get 1 sim in dropdown
      if (this.$route.fullPath.includes('figment-research')) {
        const figment = store.getters['figments/selectedFigment']
        if (arr?.length && figment?.meta?.sims?.mtn) {
          this.activeSims =
            arr.filter((s) => s.mtn === figment?.meta?.sims?.mtn) || []
          this.handleYourSMSChange(this.activeSims[0]?.mtn)
          return
        }
      }

      // filter by assigned user sim and assigned user group
      if (this.$auth.user.profile.permissions.role !== 'admin') {
        this.activeSims =
          services.filterSims(
            arr,
            this.awsSIMS,
            this.groups,
            this.$auth.user.email
          ) || []
      } else {
        // admin sees all sims
        this.activeSims = arr || []
      }

      // display inactive sims
      if (this.$auth.user.profile.permissions.role !== 'admin') {
        const arr = this.awsSIMS.filter(
          (i) => !this?.activeSims?.some((e) => e.pk === i.pk)
        )
        this.inactiveSims = services.filterSims(
          arr,
          this.awsSIMS,
          this.groups,
          this.$auth.user.email
        )
      } else {
        // admin sees all sims
        this.inactiveSims = this.awsSIMS.filter(
          (i) => !this?.activeSims?.some((e) => e.pk === i.pk)
        )
      }

      // show lock icon for each sim in a locked connection
      this.connections.forEach((c) => {
        if (c.meta.locked) {
          const sim = this.activeSims?.filter((s) => s.pk === c.meta.sim)[0]
          if (sim) {
            sim.locked = true
          }
        }
      })

      // set stores
      store.commit('sms/SET_ACTIVE_SIMS', this.activeSims)
    },
    pollSMS() {
      this.polling = setInterval(() => {
        if (this.theirSMS && this.yourSMS) {
          this.getSMSviaAWS()
        }
        this.getWANfromAWS()
      }, 3000)
    },
    cancelPoll() {
      clearInterval(this.polling)
      if (this.cancelSource !== null) {
        this.cancelSource.cancel('Stop polling service')
      }
      if (this.cancelSourceWAN !== null) {
        this.cancelSourceWAN.cancel('Stop polling service wan')
      }
    },
    getDefaultValue() {
      if (this.$route.fullPath.includes('figment-research')) {
        if (this?.activeSims?.length) {
          return this.activeSims[0]?.mtn
        }
      }
    },
    handleYourSMSChange(value, isDelete) {
      this.cancelPoll()
      if (isDelete !== 'isDelete') {
        this.theirSMS = 'All'
      }
      this.messageList = null
      this.awsReceivedMessages = []
      this.lastEvaluatedKey = null

      const activeSim = this.activeSims.filter((i) => i.meta.mtn === value)[0]
      if (activeSim) {
        this.yourSMS = this.activeSims.filter((i) => i.mtn === value)[0]
        this.yourSMS.connectionId = this.connections.filter(
          (i) => i.meta.sim === this.yourSMS.pk
        )[0].meta.id
        this.getSMSviaAWS()
        this.pollSMS()
      } else {
        this.yourSMS = this.awsSIMS.filter((i) => i.mtn === value)[0]
        this.showModal()
      }
      this.scrollToBottom()
    },
    handleTheirSMSChange(value) {
      this.theirSMS = value
      if (value) {
        this.buildMessageList()
      }
      this.scrollToBottom()
    },
    scrollToBottom() {
      setTimeout(() => {
        const container = document.getElementsByClassName('sc-message-list')[0]
        container.scrollTop = container.scrollHeight
      }, 500)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    async onMessageWasSent(message) {
      if (this.theirSMS && this.theirSMS === 'All') {
        return
      }

      message.timestamp = new Date()
      message.date = dayjs().format('YYYY-MM-DDTHH:mm')
      message.data.meta = dayjs().format('YYYY-MM-DDTHH:mm')
      message.yourSMS = this.yourSMS.mtn
      message.theirSMS = this.theirSMS
      message.hardwareId = this.hardwareId
      message.connectionId = this.yourSMS.connectionId
      message.pk = this.hardwareSerial
      message.sk = message.timestamp
      this.awsSentMessages = [...this.awsSentMessages, message]
      this.messageList = [...this.messageList, message]

      this.messageSending > 0
        ? setTimeout(() => {
            this.sendMessage(message)
          }, 8000 * this.messageSending)
        : this.sendMessage(message)
      this.messageSending += 1
    },
    sendMessage(message) {
      const options = {
        method: 'GET',
        url: process.env.VUE_APP_KONSUL_API_URL + '/router/sms/send',
        headers: { 'Content-Type': 'application/json' },
        params: {
          connectionId: this.yourSMS.connectionId.toString(),
          address: this.theirSMS.toString(),
          content: message?.data?.text.toString(),
        },
      }

      axios.request(options).then(
        () => {
          this.messageSending -= 1
          httpServices.saveSent(
            message,
            this.hardwareSerial,
            this.theirSMS,
            this.yourSMS,
            false
          )
        },
        () => {
          this.messageSending -= 1
          httpServices.saveSent(
            message,
            this.hardwareSerial,
            this.theirSMS,
            this.yourSMS,
            false
          )
        }
      )
    },
    buildMessageList() {
      let messageList = []
      const theirSMSmsgs =
        this.theirSMS === 'All'
          ? this.messages
          : this.messages?.filter((m) => m.theirSMS === this.theirSMS)
      this.participants[0].name = this.theirSMS

      if (theirSMSmsgs) {
        theirSMSmsgs.forEach((m) => {
          if (m) {
            const ts = m.timestamp * 1000 - 3600
            messageList.push({
              type: 'text',
              author: 'hardware',
              date: dayjs(ts).format('YYYY-MM-DDTHH:mm'),
              timestamp: ts,
              pk: m.pk,
              sk: m.sk,
              data: {
                text: m.content || '',
                meta:
                  m?.theirSMS + ` · ` + dayjs(ts).format('YYYY-MM-DDTHH:mm'),
              },
            })
          }
        })
      }

      const sent = this.awsSentMessages?.filter(
        (m) => m.yourSMS === this.yourSMS.mtn && m.theirSMS === this.theirSMS
      )

      try {
        messageList = [...messageList, ...sent]
      } catch {
        messageList.sort()
      }

      messageList.sort((x, y) => {
        return x.timestamp - y.timestamp
      })

      if (this.clearedTimestamp) {
        messageList = messageList.filter(
          (i) => this.clearedTimestamp < i.timestamp
        )
      }

      this.messageList = messageList
    },
    buildMessageMap(messages) {
      this.messages = messages
      const msgMap = {}
      if (!messages) {
        return
      }
      messages.forEach((msg) => {
        if (msgMap[msg?.theirSMS]) {
          msgMap[msg.theirSMS].messages.push(msg)
        } else {
          msgMap[msg.theirSMS] = {
            messages: [msg],
          }
        }
        if (msgMap?.All?.messages) {
          msgMap.All.messages.push(msg)
        } else {
          msgMap.All = {
            messages: [msg],
          }
        }
      })
      this.senders = msgMap
      this.sendersNumbers = Object?.keys(this.senders)?.sort()?.reverse() || []
    },
    showModal() {
      this.modalVisible = true
    },
    handleOk(_e) {
      this.modalVisible = false
      this.changeConnection()
    },
    handleCancel(_e) {
      this.modalVisible = false
    },
    changeConnection() {
      this.connectionLoading = true
      this.connectionChanged = true
      const connections = this.connections?.filter((i) => !i.meta.locked)
      if (!connections.length) {
        this.$notification.error({
          message: `Failed: All connections are locked! Please unlock the connections or go to sims management.`,
        })
        return
      }
      const connection =
        connections[Math.floor(Math.random() * connections.length - 1)]
      const connId = connection.meta.id
      this.yourSMS.connectionId = connId
      const slotId = this.yourSMS.simSlot
      const options = {
        method: 'PUT',
        url: process.env.VUE_APP_KONSUL_API_URL + '/api/sms/link/update',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
        data: {
          hardwareId: this.hardwareId,
          connectionId: connId.toString(),
          slotId: slotId.toString(),
        },
      }
      axios.request(options).then((_r) => {
        connection.meta.loading = true
        connection.meta.sim = this.yourSMS.pk
        httpServices.updateConnection(connection.pk, connection.meta).then(
          (_res) => {
            this.$notification.warning({
              message: `Changing Connection Link...`,
            })
            setTimeout(() => {
              this.pollSMS()
            }, 15000)
          },
          (_e) => {
            this.$notification.error({
              message:
                'Failed to Update Connection - This SIM may be in use by another connection',
            })
          }
        )
      })
    },
    getWANfromAWS() {
      this.cancelSourceWAN = axios.CancelToken.source()
      httpServices
        .getConnectionsByHardware(this.hardwareId, this.cancelSourceWAN.token)
        .then((connections) => {
          this.cancelSourceWAN = null
          if (!this.connections) {
            this.connections = connections
            this.buildWan()
          } else {
            const connectionsEqual = _.isEqual(
              this.connections.map((i) => i.meta.sim),
              connections.map((i) => i.meta.sim)
            )
            if (!connectionsEqual) {
              if (this.connectionChanged) {
                this.$notification.warning({
                  message: `Your Connection Link is Establishing...`,
                })
                this.connectionLoading = true
                this.connections = connections
              } else {
                this.$notification.warning({
                  message: `Another analyst has changed your radio connection please wait for it to finish establishing...`,
                })
                setTimeout(() => {
                  this.$router.go(0)
                }, 5000)
              }
            }

            if (this.yourSMS?.connectionId) {
              const conn = connections.filter(
                (i) =>
                  i?.meta?.id?.toString() ===
                  this.yourSMS?.connectionId?.toString()
              )[0]
              if (conn && !conn?.meta?.loading) {
                if (!this.connectionLoadingTimeout && this.connectionLoading) {
                  this.connectionLoadingTimeout = true
                  setTimeout(() => {
                    this.connectionLoading = false
                    this.connectionLoadingTimeout = false
                    this.connectionChanged = false
                    this.buildWan()
                    if (conn.meta.sim === 'N/A') {
                      this.$notification.warning({
                        message: `SIM unable to connection to connection. Please contact your administrator.`,
                      })
                    } else {
                      this.$notification.success({
                        message: `Your Connection Link is Established.`,
                      })
                    }
                  }, 5000)
                }
              } else {
                // this.connectionLoading = true
              }
            }
          }
        })
    },
    toggleLock() {
      const conn = this.connections.filter(
        (i) => i.meta.sim === this.yourSMS.pk
      )[0]
      httpServices.getFigments().then((figments) => {
        const sims = figments.map((f) => f.meta.sims.pk)
        if (sims.includes(this.yourSMS.pk)) {
          this.$notification.error({
            message:
              'Cannot lock/unlock sim to connection because it is in use by a figment.',
          })
        } else {
          if (conn) {
            conn.meta.locked = !conn.meta.locked
            conn.meta.loading = false
            httpServices.updateConnection(conn.pk, conn.meta).then((_res) => {
              // reload lock icon in ui
              const locked = !this.yourSMS.locked
              this.yourSMS.locked = locked
              const clone = JSON.parse(JSON.stringify(this.yourSMS))
              this.yourSMS = null
              this.yourSMS = clone

              const activeSims = JSON.parse(JSON.stringify(this.activeSims))
              const sim = activeSims.filter((i) => i.pk === this.yourSMS.pk)[0]
              sim.locked = locked
              this.activeSims = []
              this.activeSims = activeSims

              this.$notification.success({
                message: locked ? 'Connection Locked' : 'Connection Unlocked',
              })
            })
          }
        }
      })
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    onDeleteMessage(record) {
      this.cancelPoll()
      httpServices.deleteMessage(record.message.pk, record.message.sk).then(
        (_r) => {
          this.$notification.success({
            message: `Message deleted`,
          })

          this.messageList = this.messageList.filter(
            (i) => i.timestamp !== record.message.timestamp
          )

          if (record.me) {
            this.awsSentMessages = []
          }
          this.handleYourSMSChange(this.yourSMS.mtn, 'isDelete')
        },
        (_e) => {
          this.$notification.error({
            message: `Failed to delete message`,
          })
        }
      )
    },
    onAddNewConversation(value) {
      if (value[0] !== '+' || value[1] !== '1') {
        this.$notification.error({
          message: `Please prefix phone number with a valid country code (+1)`,
        })
        return
      }
      if (value.includes(')') || value.includes('-')) {
        this.$notification.error({
          message: `Please format phone number without dashes or parentheses +15555555555`,
        })
        return
      }
      this.sendersNumbers.push(value)
      this.theirSMS = value
      this.participants[0].name = value
      this.messageList = []
      this.popoverVisible = false
    },
    handleOnType() {
      if (this.theirSMS === 'All') {
        this.$notification.error({
          message:
            'Cant send a message to all - please select one number to send to',
          duration: 2,
        })
      }
    },
    handleOnLoadPrevious() {
      this.clearedTimestamp = null
      this.handleOnScrollToTop()
      this.scrollToBottom()
    },
    handleOnScrollToTop() {
      if (this.lastEvaluatedKey === undefined) {
        this.$notification.success({
          message: `All message history has been loaded`,
        })
      } else {
        this.getSMSviaAWS(this.lastEvaluatedKey)
      }
    },
    clearMessageBox() {
      this.cancelPoll()
      this.clearedTimestamp =
        this.messageList[this.messageList?.length - 1]?.timestamp
      this.messageList = null
      this.awsReceivedMessages = []
      this.lastEvaluatedKey = null
      this.messageList = []

      setTimeout(() => {
        this.getSMSviaAWS()
        this.pollSMS()
      }, 100)
    },
    doCopy(text) {
      this.$copyText(text).then(
        () => {
          this.$notification.success({
            message: `Field Copied!`,
            duration: 2,
          })
        },
        () => {
          this.$notification.error({
            message: `Failed to Copy`,
            duration: 2,
          })
        }
      )
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    },
  },
}
</script>

<template>
  <div class="chatContainer">
    <div class="smsContainer">
      <div>
        <div class="spaced">
          <div>
            <label>Sender SMS </label>
          </div>
          <div v-if="yourSMS">
            <a-button
              size="small"
              shape="circle"
              style="margin-right: 8px"
              @click="doCopy(yourSMS.mtn)"
            >
              <a-icon type="copy" />
            </a-button>
            <a-button
              v-if="yourSMS.locked"
              :disabled="!yourSMS.pk || connectionLoading"
              shape="circle"
              size="small"
              @click="toggleLock"
            >
              <a-icon
                :theme="'twoTone'"
                :two-tone-color="'#52c41a'"
                type="unlock"
              ></a-icon>
            </a-button>
            <a-button
              v-else
              size="small"
              shape="circle"
              :disabled="!yourSMS.pk || connectionLoading"
              @click="toggleLock"
            >
              <a-icon
                :theme="'twoTone'"
                :two-tone-color="'#f5222d'"
                type="lock"
              ></a-icon>
            </a-button>
          </div>
        </div>
        <a-select
          v-if="activeSims !== null"
          placeholder="Select available SIM"
          style="width: 100%"
          :default-value="getDefaultValue()"
          @change="handleYourSMSChange"
        >
          <a-select-opt-group>
            <span slot="label"><a-icon type="check" /> Active</span>

            <a-select-option
              v-for="(sim, i) in activeSims"
              :key="i"
              :value="sim.mtn"
            >
              {{ formatPhoneNumber(sim.mtn) }}
              <a-icon
                v-if="sim.locked"
                :theme="'twoTone'"
                :two-tone-color="'#f5222d'"
                type="lock"
              />
            </a-select-option>
          </a-select-opt-group>

          <a-select-opt-group>
            <span slot="label"><a-icon type="disconnect" /> Inactive</span>

            <a-select-option
              v-for="(sim, i) in inactiveSims"
              :key="i"
              :value="sim.mtn"
            >
              {{ formatPhoneNumber(sim.mtn) }}
            </a-select-option>
          </a-select-opt-group>
        </a-select>
      </div>
      <div>
        <div id="new--convo" class="spaced">
          <label>Recipient SMS </label>

          <div class="spaced">
            <div>
              <a-button
                v-if="theirSMS"
                size="small"
                shape="circle"
                style="margin-right: 8px"
                @click="doCopy(theirSMS)"
              >
                <a-icon type="copy" />
              </a-button>
            </div>

            <div id="plusIcon">
              <a-popover
                v-model="popoverVisible"
                title="Add New Conversation"
                trigger="click"
              >
                <template slot="content">
                  <a-input-search
                    placeholder="+15555555555"
                    size="large"
                    @search="onAddNewConversation"
                  >
                    <a-button slot="enterButton">
                      <a-icon type="plus-circle" />
                    </a-button>
                  </a-input-search>
                </template>
                <a href="#">
                  <a-icon type="plus" />
                </a>
              </a-popover>
            </div>
          </div>
        </div>

        <a-select
          show-search
          placeholder="Select previous or add new"
          option-filter-prop="children"
          style="width: 100%"
          :filter-option="filterOption"
          :value="theirSMS || undefined"
          @change="handleTheirSMSChange"
        >
          <a-select-option
            v-for="(sim, i) in sendersNumbers"
            :key="i"
            :value="sim"
          >
            {{ sim }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="chat--container">
      <OverlaySpinner v-if="connectionLoading" />
      <beautiful-chat
        v-if="theirSMS && yourSMS && !connectionLoading"
        :class="{ disableSend: theirSMS === 'All' }"
        :participants="participants"
        :title-image-url="titleImageUrl"
        :on-message-was-sent="onMessageWasSent"
        :message-list="messageList || []"
        :new-messages-count="newMessagesCount"
        :is-open="true"
        :close="closeChat"
        :open="openChat"
        :show-emoji="false"
        :show-file="false"
        :show-edition="true"
        :show-deletion="true"
        :show-typing-indicator="showTypingIndicator"
        :show-launcher="false"
        :show-close-button="false"
        :colors="colors"
        :always-scroll-to-bottom="false"
        :disable-user-list-toggle="true"
        @onType="handleOnType"
        @scrollToTop="handleOnScrollToTop"
        @edit="editMessage"
      >
        <template v-slot:text-message-toolbox="scopedProps">
          <a-popconfirm
            title="Sure to delete?"
            @confirm="() => onDeleteMessage(scopedProps)"
          >
            <a href="javascript:;" title="Delete Message">
              <a-button
                type="danger"
                icon="delete"
                size="small"
                style="color: #ff4d4f"
              ></a-button>
            </a>
          </a-popconfirm>
        </template>
      </beautiful-chat>
      <div class="chatBtnContainer">
        <a-button
          v-if="theirSMS && yourSMS && messageList && !connectionLoading"
          icon="rollback"
          @click="handleOnLoadPrevious"
        >
          Load Previous
        </a-button>
        <a-button
          v-if="theirSMS && yourSMS && messageList && !connectionLoading"
          icon="delete"
          @click="clearMessageBox"
        >
          Clear
        </a-button>
      </div>
    </div>
    <div v-if="!yourSMS || !theirSMS" class="helper">
      <p v-if="!connectionLoading" class="ant-card-meta-description">
        <span v-if="!theirSMS || !yourSMS">
          <a-icon
            type="exclamation-circle"
            theme="filled"
            style="margin-right: 8px"
        /></span>
        <span v-if="!yourSMS">Select your sms</span>
        <span v-if="!theirSMS && !yourSMS">&nbsp; &middot; &nbsp;</span>
        <span v-if="!theirSMS">Select their sms</span>
      </p>
    </div>
    <a-modal
      title="This SIM isn't active on a radio."
      :visible="modalVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="modal--container">
        <img
          src="https://vanished-fe.s3.us-east-2.amazonaws.com/signal.svg"
          alt="signal logo"
        />
        <p>Click OK to assign it to a radio for SMS.</p>
      </div>
    </a-modal>
  </div>
</template>

<style lang="scss">
.smsContainer {
  margin-bottom: 8px;
}

.smsContainer > div {
  margin-bottom: 0.75rem;
}

.smsContainer .ant-select {
  margin-top: 0.25rem;
}

.sc-header {
  min-height: auto !important;
  padding: 0 !important;
}

.sc-chat-window.opened {
  margin-bottom: 0 !important;
}

.helper {
  text-align: center;
}

.spaced {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.chatBtnContainer {
  > button {
    width: 48%;

    &:first-of-type {
      margin-right: 2%;
    }
  }

  @media screen and (max-width: 900px) {
    > button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

#new--convo {
  #plusIcon {
    min-width: 24px;
    height: 24px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #d9d9d9 !important;
    border-radius: 50%;
    box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover {
      color: #40a9ff;
      cursor: pointer;
      background-color: #fff;
      border-color: #40a9ff !important;
    }
  }
}

form.sc-user-input {
  margin-bottom: 0.4rem !important;
}

.disableSend form.sc-user-input {
  display: none;
}

.modal--container {
  text-align: center;

  img {
    width: 200px;
    opacity: 0.9;
  }
}
</style>
